import { Preferences } from "@capacitor/preferences";

export type DownloadedFile = {
  id: string;
  name: string;
  uri: string;
  mimeType: string;
  savedAt: string;
  sizeBytes?: number;
};

const KEY = "app_downloads_v1";

export async function listDownloads(): Promise<DownloadedFile[]> {
  const { value } = await Preferences.get({ key: KEY });
  if (!value) return [];
  try {
    const parsed = JSON.parse(value) as DownloadedFile[];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export async function addDownload(file: DownloadedFile): Promise<void> {
  const current = await listDownloads();
  const deduped = current.filter((d) => d.uri !== file.uri);
  deduped.unshift(file);
  await Preferences.set({ key: KEY, value: JSON.stringify(deduped) });
}

export async function removeDownload(id: string): Promise<void> {
  const current = await listDownloads();
  const next = current.filter((d) => d.id !== id);
  await Preferences.set({ key: KEY, value: JSON.stringify(next) });
}

export async function clearDownloads(): Promise<void> {
  await Preferences.remove({ key: KEY });
}
